package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_05_02_Day_1
import com.veldekar.components.logs.Log_2026_05_02_Day_2
import com.veldekar.components.logs.Log_2026_05_02_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-05-02")
@Composable
public fun Log_2026_05_02(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Spirit Trolls Goin’ Down!",
        ogTitle = "Spirit Trolls Goin’ Down!",
        date = LocalDate(2_026, 5, 2),
        aiHint = "The campaign involved 'Spirit Trolls' and the image, title and description twist that into 'Spirit Airlines' (a failed business in the real world) and Trolls (the dolls from the 90s).",
        ogDescription = "On the same night that Spirit Airlines ceased operations and began liquidation, the heroes learned the weaknesses of the Spirit Trolls.",
        ogImage = "images/spiritTrolls.webp",
        ogImageWidth = 1_195,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of two '90s troll dolls flying a 'Spirit' biplane with a fairy trash talking them. This is a reference to Spirit Airlines, a failed company, and the troll dolls are meant to represent Spirit Trolls.",
    ) {
        SessionDayHeader(dayId = "shimmer-29", dateString = "Shimmer 29")
        Log_2026_05_02_Day_1()
        SessionDayHeader(dayId = "shimmer-30", dateString = "Shimmer 30")
        Log_2026_05_02_Day_2()
        SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31")
        Log_2026_05_02_Day_3()
        SessionMediaItem(
            image = "images/spiritTrollsJustPlane.webp",
            linkImage = "images/spiritTrollsJustPlane.webp",
            description = "A hand-drawn illustration of two '90s troll dolls flying a 'Spirit' biplane with a fairy trash talking them. This is a reference to Spirit Airlines, a failed company, and the troll dolls are meant to represent Spirit Trolls.",
            width = 2_564,
            height = 1_630,
        )
    }
}
